import { render, staticRenderFns } from "./GruposLista.vue?vue&type=template&id=0230524a&scoped=true&"
import script from "./GruposLista.vue?vue&type=script&lang=js&"
export * from "./GruposLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0230524a",
  null
  
)

export default component.exports